// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-and-tools-drawer {\n  width: 534px;\n  font-size: 16px;\n}\n.setting-and-tools-drawer .el-drawer__header {\n    margin-bottom: 10px;\n}\n.setting-and-tools-drawer .el-drawer__body {\n    padding: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
